import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)
const state = {
    userInfo:{},
    exerciseType:[2,3,4,607]
}
const mutations={
    setUserInfo(state,info){
        state.userInfo = info
    }
}
export default new Vuex.Store({
    state,mutations
   });


// WEBPACK FOOTER //
// ./src/store/index.js